export default __webpack_public_path__ + "maps-examples-offline-storage-thumbnail-480-e5d6ffa9466986a6ea571d019781f9dc.webp";